import { RWCMUIThemeProvider, RWCSnackbarProvider } from '@caju-beneficios/react-web-commons';
import { SV2Providers } from '@caju-beneficios/sponsor-v2-lib';
import { AppContent } from './AppContent';
import { CssBaseline } from '@material-ui/core';

export function App() {
  return (
    <RWCMUIThemeProvider>
      <RWCSnackbarProvider>
        <CssBaseline />
        <SV2Providers>
            <AppContent />
        </SV2Providers>
      </RWCSnackbarProvider>
    </RWCMUIThemeProvider>
  );
}